import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Authenticate from "../views/Authenticate.vue";
import Itsepalvelu from "../views/Itsepalvelu.vue";
import Kykyviisari from "../views/Kykyviisari.vue";
import SkillsPage from "../views/SkillsPage.vue";
import SkillBoard from '../views/SkillBoard.vue';
import KeywordsAndJobs from '../views/KeywordsAndJobs.vue';
import ServiceRequirement from '../views/ServiceRequirement.vue';
import axios from "axios";
import Cookies from "js-cookie";
import { verifyAuth } from "@/helpers";
import store from "@/store";
import { i18n } from '@/main';

Vue.use(VueRouter);

const routes = [
	{
		path: "/:org?",
		name: "Home",
		component: Home,
		props: true,
		meta: {
			title: "Itsepalvelu",
			dontVerifyAuth: true
		}
	},
	{
		path: "/:org/:lang/",
		name: "Itsepalvelu",
		component: Itsepalvelu,
		props: true,
		meta: {
			title: "Itsepalvelu",
			authRequired: true
		}
	},
	{
		path: "/:org/:lang/Kykyviisari",
		name: "Kykyviisari",
		component: Kykyviisari,
		props: true,
		meta: {
			title: "Arvioinnit ja suunnitelmat",
			authRequired: true
		}
	},
	{
		path: "/:org/:lang/Kokemus",
		name: "Skills",
		component: SkillsPage,
		props: true,
		meta: {
			title: "Osaaminen ja kokemus",
			authRequired: true
		}
	},
	{
		path: "/:org/:lang/Taitotaulu",
		name: "Skillboard",
		component: SkillBoard,
		props: true,
		meta: {
			title: "Taitotaulu",
			authRequired: true
		}
	},
	{
		path: "/:org/:lang/AvainsanatJaTyopaikat",
		name: "KeywordsAndJobs",
		component: KeywordsAndJobs,
		props: true,
		meta: {
			title: "Työpaikka- ja koulutussuositukset",
			authRequired: true
		}
	},
	{
		path: "/:org/:lang/PalvelutarpeenArviointi",
		name: "ServiceRequirement",
		component: ServiceRequirement,
		props: true,
		meta: {
			title: "Palvelutarpeen arviointi",
			authRequired: true
		}
	},
	{
		path: "/:org/about",
		name: "About",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "about" */ "../views/About.vue"),
		props: true,
		meta: {
			title: "Itsepalvelu"
		}
	},
	{
		path: "/:org/:lang/auth/:authKey?",
		name: "Authenticate",
		component: Authenticate,
		props: true,
		meta: {
			title: "Itsepalvelu"
		}
	}
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
});

router.beforeEach(async (to, from, next) => {
	if (!to.meta.dontVerifyAuth && to.params.org) {
		axios.defaults.headers.org = to.params.org;
		const jwt = Cookies.get("jwt");
		if (jwt) {
			const ok = await verifyAuth(store, jwt);
			if (!ok && to.meta.authRequired) {
				router.push({ name: "Home", params: { org: to.params.org } })
			}
		}
		if (to.name == 'Skillboard' && !store.state.orgServices?.includes('taitotaulu')) {
			router.push({ name: "Itsepalvelu", params: { org: to.params.org, lang: to.params.lang } })
		}
		if (to.name == 'Kykyviisari' && !store.state.orgServices?.includes('kykyviisari')) {
			router.push({ name: "Itsepalvelu", params: { org: to.params.org, lang: to.params.lang } })
		}
      if (to.name == 'KeywordsAndJobs' && !store.state.orgServices?.includes('työpaikkasuositukset')) {
			router.push({ name: "Itsepalvelu", params: { org: to.params.org, lang: to.params.lang } })
		}
	}
	next();
});

router.afterEach((to) => {
	Vue.nextTick(() => {
		document.title = to.meta.title;
		i18n.locale = store.state.lang;
	})
})

export default router;
